import { CommonStyles } from '../../../../../../../../../../../../ui-library/styles/common.styles'

export const ConsumerAutoAddressFormStyles = {
  container: 'w-full flex flex-col items-center',
  submitButton: 'text-xl sm:text-2xl mt-auto',
  manualButton: `${CommonStyles.anchorLink} text-left mt-4 mb-6`,
}
